module.exports = __webpack_public_path__ + "static/media/virtualDom.c158617e.gif";